import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const ReactCreatableSelect = ({
  options = [], 
  field,  
  id = [], 
  multi = false
}) => {

  const [val, setVals] = useState(id);

  useEffect(() => {
    if (field) {
      const el = document.getElementById(field);
        el.value = JSON.stringify(val.map((v) => v.value));
    }
  }, [val]);

  return (
      <div>
          <CreatableSelect
              className="max-w-md w-full"
              isMulti={multi}
              defaultValue={id}
              onChange={(value) => {
                setVals(value)
              }}
              options={options}
              placeholder={<div>Create</div>}
          />
      </div>
  )
}


export default ReactCreatableSelect;